/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* SANAME v2.6.16.12 - production variant integrity guard
 * Keeps visible size, Shopify variant ID and Appstle on the same variant.
 */
(function () {
  'use strict';

  function syncFormVariant(form, variantId, notify) {
    if (!form || !variantId) return;
    var field = form.querySelector('[name="id"]');
    if (!field) return;

    var id = String(variantId);
    if (field.tagName === 'SELECT') {
      field.value = id;
      Array.prototype.forEach.call(field.options, function (option) {
        option.selected = String(option.value) === id;
      });
    } else {
      field.value = id;
    }

    form.setAttribute('data-saname-current-variant-id', id);

    if (notify) {
      try { field.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
      try { field.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) {}
    }
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant) return;
    var root = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : null;
    var form = root ? root.querySelector('form[action*="/cart/add"]') : null;
    syncFormVariant(form, variant.id, false);
  });

  function enforceBeforePurchase(target) {
    var form = target && target.closest ? target.closest('form[action*="/cart/add"]') : null;
    if (!form) return;
    var expected = form.getAttribute('data-saname-current-variant-id');
    if (expected) syncFormVariant(form, expected, false);
  }

  // Capture phase runs before Prestige/Appstle click handlers.
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-action="add-to-cart"], .shopify-payment-button__button') : null;
    if (button) enforceBeforePurchase(button);
  }, true);

  document.addEventListener('submit', function (event) {
    if (event.target && event.target.matches && event.target.matches('form[action*="/cart/add"]')) {
      enforceBeforePurchase(event.target);
    }
  }, true);
})();
